import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// react-bootstrap
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import Nav from 'react-bootstrap/Nav';
import Stack from 'react-bootstrap/Stack';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

import Img2 from 'assets/images/user/avatar-2.png';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentLanguage } from '../../store/slices/language/languageSlice';
import { useTranslation } from 'react-i18next';
import i18n from '../../config/i18n';
import { logout } from '../../store/slices/auth/authSlice';
import { fetchLocationById } from '../../store/slices/location/locationThunk';
import { ChangePassword } from '../../views/navigation/ChangePassword';

// =============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const { t } = useTranslation(); // Use this for translating static text in header
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;
  const { currentLocation } = useSelector((store) => store.location);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, role } = useSelector((state) => state.auth);
  const languageState = useSelector((state) => state.language);
  const languages = languageState.languages;
  const [ show, setShow] = useState(false)

  // 3. Local state should initialize from Redux or LocalStorage
  const [selectedLang, setSelectedLang] = useState({
    lang_code: localStorage.getItem('i18nextLng') || 'en',
    lang: 'English',
    flag: '🇺🇸'
  });

  // 4. Function to handle switching
  const handleLanguageChange = (item) => {    
    // Update i18next engine.
    localStorage.setItem('i18nextLng', item.lang_code);
    i18n.changeLanguage(item.lang_code);

    // Update Local Storage
    

    // Update Redux Store (Global State)
    dispatch(setCurrentLanguage(item.lang_code));

    // Update Local UI State
    setSelectedLang(item);
    
  };

  const handleLogout = () => {
     dispatch(logout())
  }

  useEffect(() => {
    if (role === "ADMIN" && currentLocation === null){
      dispatch(fetchLocationById(user.locationId ?? 0))
    }
  },[])

  // 5. Sync state on initial load
useEffect(() => {
    const currentLangCode = localStorage.getItem('i18nextLng') || 'en';
    const matchedLang = languages.find((l) => l.lang_code === currentLangCode);

    if (matchedLang) {
      setSelectedLang(matchedLang);
      dispatch(setCurrentLanguage(matchedLang.lang_code));
      // Ensure the i18n instance matches the stored preference
      if (i18n.language !== matchedLang.lang_code) {
        i18n.changeLanguage(matchedLang.lang_code);
      }
    }
  }, [languages, dispatch, i18n]);

  return (
    <header className="pc-header">
      <div className="header-wrapper">
        <div className="me-auto pc-mob-drp">
          <Nav className="list-unstyled">
            <Nav.Item className="pc-h-item pc-sidebar-collapse">
              <Nav.Link
                as={Link}
                to="#"
                className="pc-head-link ms-0"
                id="sidebar-hide"
                onClick={() => {
                  handlerDrawerOpen(!drawerOpen);
                }}
              >
                <i className="ph ph-list" />
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="pc-h-item pc-sidebar-popup">
              <Nav.Link as={Link} to="#" className="pc-head-link ms-0" id="mobile-collapse" onClick={() => handlerDrawerOpen(!drawerOpen)}>
                <i className="ph ph-list" />
              </Nav.Link>
            </Nav.Item>

            <Dropdown className="pc-h-item dropdown">
              {/* <Dropdown.Toggle variant="link" className="pc-head-link arrow-none m-0 trig-drp-search" id="dropdown-search">
                <i className="ph ph-magnifying-glass" />
              </Dropdown.Toggle> */}
              <Dropdown.Menu className="pc-h-dropdown drp-search">
                <Form className="px-3 py-2">
                  <Form.Control type="search" placeholder="Search here. . ." className="border-0 shadow-none" />
                </Form>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>

        <div className="ms-auto">
          <Nav className="list-unstyled">
            {/* --- LANGUAGE SELECTED DROPDOWN --- */}
              <Nav.Item className="pc-h-item">
                  <h6 style={{cursor:"pointer "}} onClick={() => navigate('/location/current-location', { replace: true })}>{ role === "ADMIN" && currentLocation?.address}</h6>
                </Nav.Item>
            <Dropdown className="pc-h-item" align="end">
              <Dropdown.Toggle
                variant="link"
                className="pc-head-link me-0 arrow-none d-flex align-items-center gap-2"
                id="language-dropdown"
                style={{ textDecoration: 'none' }}
              >
                <i className="ph ph-globe" />
                {/* Dynamically show the current language code */}
                <span className="badge bg-dark pc-h-badge">{selectedLang.lang_code.toUpperCase()}</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="pc-h-dropdown">
                {languages.map((item) => (
                  <Dropdown.Item
                    key={item.lang_code}
                    onClick={() => handleLanguageChange(item)}
                    className="d-flex align-items-center gap-3"
                    active={selectedLang.lang_code === item.lang_code}
                  >
                    <span>{item.flag}</span>
                    <span>{item.lang}</span>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {/* ---------------------------------- */}
            <Dropdown className="pc-h-item" align="end">
              <Dropdown.Toggle
                className="pc-head-link arrow-none me-0"
                variant="link"
                id="user-profile-dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="ph ph-user-circle" />
              </Dropdown.Toggle>

              <Dropdown.Menu className=" dropdown-user-profile pc-h-dropdown p-0 overflow-hidden">
                <Dropdown.Header className="bg-dark">
                  <Stack direction="horizontal" gap={3} className="my-2">
                    <div className="flex-shrink-0">
                      <Image src={Img2} alt="user-avatar" className="user-avatar wid-35" roundedCircle />
                    </div>
                    <Stack gap={1}>
                      <h6 className="text-white mb-0">{user?.name}</h6>
                      <span className="text-white text-opacity-75">{user?.email}</span>
                    </Stack>
                  </Stack>
                </Dropdown.Header>

                <div className="dropdown-body">
                  <div className="profile-notification-scroll position-relative" style={{ maxHeight: 'calc(100vh - 225px)' }}>
                    {/* <Dropdown.Item as={Link} to="#" className="justify-content-start">
                      <i className="ph ph-gear me-2" />
                      Settings
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="#" className="justify-content-start">
                      <i className="ph ph-share-network me-2" />
                      Share
                    </Dropdown.Item> */}
                    <Dropdown.Item  className="justify-content-start" onClick={() => {setShow(true)}}>
                      <i className="ph ph-lock-key me-2"  />
                      Change Password
                    </Dropdown.Item>
                    <div className="d-grid my-2">
                      <Button variant='dark' onClick={handleLogout}>
                        <i className="ph ph-sign-out align-middle me-2" />
                        Logout
                      </Button>
                    </div>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </div>
      <ChangePassword show={show} handleClosePopup={() => setShow(false)}/>
    </header>
  );
}
